import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FiftyMB, TwoHundredMB } from 'src/app/types/constants/app.constant';
import { ToastService } from '../toast/toast.service';

type fileTypes =  'xls'|'xlsx'|'pdf'|string
@Component({
  selector: 'app-drag-drop-file',
  templateUrl: './drag-drop-file.component.html',
  styleUrls: ['./drag-drop-file.component.scss']
})
export class DragDropFileComponent implements OnChanges {
  @Output() fileChanged: EventEmitter<File> = new EventEmitter<File>;
  @Output() deleteHandler: EventEmitter<{file:File|null,fileName:string}> = new EventEmitter<{file:File|null,fileName:string}>();
  @Output() previewHandler: EventEmitter<{file:File|null,fileName:string}> = new EventEmitter<{file:File|null,fileName:string}>();
  @Output() downloadHandler: EventEmitter<{file:File|null,fileName:string}> = new EventEmitter<{file:File|null,fileName:string}>();

  @ViewChild('hiddenInput') hiddenInput: ElementRef;
  @Input() disabled: boolean;
  @Input() elementId: string;
  @Input() error: boolean = false;
  @Input() fileTypes: fileTypes[] = ['xls', 'xlsx'];
  @Input() maxSize: number = FiftyMB; // FiftyMB | TwoHundredMB, Default FiftyMB
  @Input() patchFileName: string;
  @Input() componentName: string;
  @Input() useViewBtn: boolean = true;
  @Input() useDownloadBtn: boolean = false;
  @Input() useDeleteBtn: boolean = true;

  isDragging: boolean = false;
  dragEnter: boolean = false;
  file: File|null = null;
  fileName: string = '';
  constructor(private toast: ToastService, private cdRef: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.patchFileName) {
      this.fileName = this.patchFileName;
    }
  }

  filterFileInput() {
    const formats: string[] = [...this.fileTypes];
    formats.forEach((item, index) => {
      formats[index] = `.${item}`;
    });
    return formats;
  }

  reset() {
    this.file = null;
    this.fileName = '';
    this.cdRef.detectChanges();
  }

  validateFile(file: File) {
    try {
      const fileExtension = file.name.split('.').pop()?.toLowerCase() as string;
      if (!this.fileTypes.includes(fileExtension)) {
        this.toast.error('UPLOAD_FILE.INVALID_TYPE', { types: this.fileTypes.join(',').toUpperCase() });
      } else if (file.size > this.maxSize) {
        this.toast.error('UPLOAD_FILE.TOO_LARGE', { size: this.maxSize===TwoHundredMB? 200:50 });
      } else {
        this.file = file;
        this.fileName = file.name;
        this.fileChanged.emit(this.file);
      }
    }
    catch (err) {
        this.toast.error('UPLOAD_FILE.SYSTEM_ERROR');
    } finally {
      this.isDragging = false;
    }
  }
  handleFileInput(event: any) {
    this.validateFile(event.target.files[0]);
    event.target.value = null; //clear cache
  }

  handleDragOver(event: any) {
    event.preventDefault();
  }

  handleDragMove(event: any) {
    if (!event.relatedTarget || !this.elementContains(event.currentTarget as HTMLElement, event.relatedTarget as HTMLElement)) {
      this.isDragging = false;
    } else {
      this.isDragging = true;
    }
  }

  private elementContains(parent: HTMLElement, child: HTMLElement): boolean {
    return parent.contains(child);
  }

  handleDrop(event: any) {
    event.preventDefault();
    this.validateFile(event.dataTransfer.files[0]);
  }

  deleteClicked(): void {
    this.reset();
    this.deleteHandler.emit({file:this.file, fileName: this.fileName});
  }
  
  downloadClicked(): void {
    this.downloadHandler.emit({file:this.file, fileName: this.fileName});
  }

  previewClicked(): void {
    this.previewHandler.emit({file:this.file, fileName: this.fileName});
  }

  isPdf(name:string): boolean {
    if (!name) return false;
    const arr = name?.split('.');
    if (!arr||arr.length<1) return false;
    return (arr[arr.length-1]+'').toLowerCase() === 'pdf';
  }

}
